import { CartoKeplerMapConfigEnvelope } from 'features/maps/types'

/**
 * Updates the layers config in visState and avoid persisting custom marker URLs
 * If a custom marker ID is provided, it removes the corresponding custom URL.
 */
export const updateLayerCustomMarkers = (keplerConfig: CartoKeplerMapConfigEnvelope) => {
  return keplerConfig.config.visState.layers.map((layer) => ({
    ...layer,
    config: {
      ...layer.config,
      visConfig: {
        ...layer.config.visConfig,
        customMarkersId: layer.config.visConfig.customMarkersId,
        customMarkersUrl: layer.config.visConfig.customMarkersId ? undefined : layer.config.visConfig.customMarkersUrl,
        customMarkersRange: layer.config.visConfig.customMarkersRange
          ? layer.config.visConfig.customMarkersRange.markerMap
            ? {
                ...layer.config.visConfig.customMarkersRange,
                othersMarker: layer.config.visConfig.customMarkersRange.othersMarkerId
                  ? undefined
                  : layer.config.visConfig.customMarkersRange.othersMarker,
                othersMarkerId: layer.config.visConfig.customMarkersRange.othersMarkerId,
                markerMap: layer.config.visConfig.customMarkersRange.markerMap.map((markerMap) => ({
                  ...markerMap,
                  markerId: markerMap.markerId,
                  markerUrl: markerMap.markerId ? undefined : markerMap.markerUrl
                }))
              }
            : { ...layer.config.visConfig.customMarkersRange }
          : undefined
      }
    }
  }))
}
